import Vue from "vue";
import { Component } from "vue-property-decorator";

import "../../scripts/ah.mb.client-notifications";

import { bootbox, IBootBoxPrompt } from "../../infrastructure/bootbox-shim";

import { NotificationApiServices, NotificationSeverity, INotificationEditorModel } from "../../scripts/ah.mb.notification-services";
import { ModelLockApi} from "../../scripts/ah.mb.model-lock-services";


// Todo: Doesn't work, needs signalr

@Component
export default class NotificationsAdmin extends Vue {


    created() {
        this.notificationServices = new NotificationApiServices();
        this.modelLockServices = new ModelLockApi();

    }
    // Create notificationServices
    private notificationServices: NotificationApiServices;
    private modelLockServices: ModelLockApi;

    private notification: INotificationEditorModel = { severity: "Info", message: "" };


    handleMessageChange(value) {
        this.notification.message = value;
    }

    handleSeverityChange(value) {
        this.notification.severity = value;
    }

    private showNotificationEditor: boolean;

    data() {

        return {
            showNotificationEditor: this.showNotificationEditor,
//            notification: notification
    }

    }

    createMaintenanceNotification() {

        //     data - objectid="@Url.Action("Create", "NotificationsApi")

        var createFunc = (value: string) =>
            this.notificationServices.createSiteDownNotification(value)
            .then(data => {
                bootbox.alert(data,
                    () =>
                    this.modelLockServices.lockAllModels());
            });


        var promptSettings: IBootBoxPrompt = {
            title: "Site down message",
            content: "Site is currently down for maintenance, please try again shortly",
            callback: (result: string) => {
                createFunc(result);
            }
        };


        var showPrompt = () => {
            bootbox.prompt(promptSettings);

            this.createNotification(
                "Site is going down for brief maintenance at xxx MST.  Please finish your work.",
                NotificationSeverity.Warning,
                ok => {

                    bootbox.confirm("Disable site logins?",
                        doPrevent => {
                            if (doPrevent) {
                                showPrompt();

                            }
                        });
                });
        }
    }


    createNotificationButtonClick() {
        this.showNotificationEditor = true;
    }

    createNotification(prompt: string, severity: NotificationSeverity, callback:(ok: boolean) => void) {
        this.notificationServices.createNotification(prompt, severity)
            .then(data => {
                    bootbox.alert(data, () => { callback(true); });
            });


    }

    notificationEditorClosed() {

        const severity = (<any>NotificationSeverity)[this.notification.severity];
            this.createNotification(this.notification.message,
                severity,
                () => {

                });
    }


    cancelAllNotifications() {
    // data-objectid="@Url.Action("Cancel", "NotificationsApi")"

    bootbox.confirm("Clear all notifications?",
        ok => {
            if (ok) {
                this.notificationServices.clearNotifications();

            };

        });
}

}



// WEBPACK FOOTER //
// ./ClientApp/components/notifications/notifications-admin.ts